import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

import { ReactComponent as Flecha } from '../../../../assets/svg/Flecha.svg';

import './homeCliente.scss';

const SucursalesButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '0.8rem',
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  color: 'white',
  backgroundColor: '#2D72B4',
  borderColor: 'white',
  width: '150px',
  fontFamily: [
    'Verdana',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif'
  ].join(','),
  '&:hover': {
    borderColor: '#8d8d8d',
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
    color: 'white',
    backgroundColor: '#2D72B4',
    borderColor: 'white'
  },
  '&:focus': {
      boxShadow: 'none',
      color: 'white',
      backgroundColor: '#2D72B4',
      borderColor: 'white'
    },
});

export default function homeCliente() {
    return (
        <>
            <div className='home-cliente-container'>
                <div className='home-cliente-banner'>   
                    <div className='home-cliente-sistema'>
                        <div className='home-cliente-sistema-titulo'>
                            Servicios de soporte nutricional<br />y cuidados paliativos domiciliarios.
                        </div>
                    </div>
                </div>

                <div className='home-cliente-texto'>
                  Nutrihome se adapta a las necesidades del paciente ofreciendo un programa de atención modulado o por prestaciones requeridas a los fines de lograr un Soporte Nutricional Domiciliario individualizado, eficiente y sin complicaciones. Estas prestaciones incluyen distintas modalidades de atención, según lo pactado con el financiador (obras sociales o prepagas).
                </div>

                <div className='home-cliente-secciones'>
                    <div className='home-cliente-seccion'>
                        <div className='home-cliente-seccion-titulo'>
                            ¿Qué brinda<br /> Nutrihome?
                        </div>
                        <div className='home-cliente-seccion-descripcion'>
                          Recursos técnicos y el equipamiento necesario para garantizar la máxima eficacia en la prestación de su servicio.
                        </div>
                        <a href="https://www.nutrihome.com.ar/que-brinda-nutri-home/" color="#2D72B4" underline="none" title="Leer más acerca de qué brinda Nutrihome" target="_blank">
                            <div className='home-cliente-seccion-link'>
                                Leer más
                                <Flecha />
                            </div>
                        </a>                                                        
                    </div>
                    <div className='home-cliente-seccion'>
                        <div className='home-cliente-seccion-titulo'>
                            Política de<br /> Calidad
                        </div>
                        <div className='home-cliente-seccion-descripcion'>
                          Nuestro propósito y compromiso es ser líderes en el suministro de servicio de alta calidad, seguros, accesibles y efectivos apara los pacientes.
                        </div>
                        <a href="#dv-politicas" color="#2D72B4" underline="none" title="Leer más acerca de Política de Calidad">
                            <div className='home-cliente-seccion-link'>
                                Leer más
                                <Flecha />
                            </div>
                        </a>
                    </div>
                    <div className='home-cliente-seccion'>
                        <div className='home-cliente-seccion-titulo'>
                          ¿Como ingresar a un paciente?
                        </div>
                        <div className='home-cliente-seccion-descripcion'>
                          Pasos a seguir para el ingreso de un paciente al sistema de soporte nutricianal domiciliario.
                        </div>
                        <a href="https://www.nutrihome.com.ar/como-ingresar-un-paciente.php" color="#2D72B4" underline="none" title="¿Cómo ingresar a un paciente?" target="_blank">
                            <div className='home-cliente-seccion-link'>
                                Leer más
                                <Flecha />
                            </div>
                        </a>                 
                    </div>
                    <div className='home-cliente-seccion'>
                        <div className='home-cliente-seccion-titulo'>
                          Conoce todos<br /> los servicios
                        </div>
                        <div className='home-cliente-seccion-descripcion'>
                          Descarga el vademecúm completo.
                        </div>
                        <a href="https://www.nutrihome.com.ar/pdf/vademecum.pdf" color="#2D72B4" underline="none" title="Vademecum" target='_blank'>
                            <div className='home-cliente-seccion-link'>
                                Descargar
                                <Flecha />
                            </div>
                        </a>                
                    </div>
                </div>

                <div className='home-cliente-valores-grilla'>
                    <div id="dv-valores" className='home-cliente-valores-column home-cliente-medicos'>
                        <div className='home-cliente-valores-bloque'>
                            <div className='home-cliente-valores-texto-centrado'>
                              Cubrimos todos los aspectos de la práctica a través de nuestros equipos de profesionales especializados.
                            </div>
                        </div>
                    </div>
                    <div id="dv-politicas" className='home-cliente-valores-column home-cliente-gris'>
                        <div className='home-cliente-valores-bloque'>
                            <div className='home-cliente-valores-titulo'>
                                Política de<br /> Calidad
                            </div>
                            <div className='home-cliente-valores-texto'>
                              Nuestro propósito y compromiso es ser líderes en el suministro de servicios de soporte nutricional y cuidados de la salud de alta calidad, seguros, accesibles y efectivos para los pacientes.
                              <br /><br />
                              <strong>Llevamos a cabo este compromiso con la finalidad de:</strong>
                            </div>
                            <div className='home-cliente-valores-texto'>
                              <ul>
                                <li>Adoptar las expectativas de los clientes, usuarios y los requerimientos aplicables y al mismo tiempo cumplirlas o superarlas constantemente, optimizando nuestros procesos y servicios.</li>
                                <li>Monitorear continuamente la seguridad del paciente y la efectividad de los servicios prestados.</li>
                                <li>Mantener un Sistema de Gestión de la Calidad transparente, bien documentado, controlado y conforme a la normativa, mejorando continuamente su idoneidad, adecuación y eficacia.</li>
                                <li>Contar con una organización competente y bien capacitada con responsabilidades y autoridades claramente definidas.</li>
                                <li>Perseguir la mejora continua y la gestión efectiva de riesgos e información.La calidad de nuestros servicios, el cumplimiento del Sistema de Gestión de la Calidad y los valores de la organización son responsabilidad de cada empleado.</li>
                              </ul>                              
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className='home-cliente-valores-grilla' style={{ margin: '30px 0 30px 0' }}>                    
                    <div id="dv-valores" className='home-cliente-valores-column home-cliente-gris-oscuro'>
                        <div className='home-cliente-valores-bloque'>
                            <div className='home-cliente-valores-titulo'>
                                Newsletter
                            </div>
                            <div className='home-cliente-valores-texto'>
                              Suscribite a nuestros newsletter para recibir las novedades de marketing y promociones de Nutrihome. Simplemente completá el formulario indicando tu correo electrónico.
                              <br /><br />
                              <a href="https://www.nutrihome.com.ar/proteccion-datos.php" style={{ color: '#2D72B4', fontSize: '14px', fontWeight: 700, textDecoration: 'underline'}} title="Términos y Condiciones" target='_blank'>Ver términos y condiciones.</a>
                            </div>
                        </div>
                    </div>
                    <div id="dv-valores" className='home-cliente-valores-column home-cliente-azul'>
                        <div className='home-cliente-valores-bloque'>
                            <div className='home-cliente-valores-titulo white'>
                                ¿Dónde estamos?
                            </div>
                            <div className='home-cliente-valores-texto white'>
                              Estamos presentes en todo el país. Para conocer la sucursal más cercana a tu domicilio simplemente hace click en "Ver Sucursales".
                              <br /><br />
                              <SucursalesButton variant="outlined" href="https://www.nutrihome.com.ar/sucursales/" target="_blank" title='Ver Sucursales'>VER SUCURSALES</SucursalesButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};